//-- primefaces
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';

//-- app
import { I18NService } from '../utils/i18n.service';
import { GLOBALS } from 'src/app/app-globals';
import { HttpClient } from '@angular/common/http';
import { RestClient } from '../../rest-client.service';
import { Observable, map, of, tap } from 'rxjs';
import { EnumIbanCountry } from '../../model/dto.models.imported';


/**
 * Model - ResponseXBVO
 */
export enum EnumSalutation {
	MR,
	MRS,
	FAMILY,
	COMPANY
}


@Injectable({
    providedIn: 'root'
})
export class SelectItemsState {

	private i18n: I18NService;
	private noSelectionOption: SelectItem;
	public salutations: SelectItem[];
	public genders: SelectItem[];
	public ibanCountries: SelectItem[] = Object.keys(EnumIbanCountry).map(iCountry=>({label: iCountry, value: iCountry}));



	/*
	 * Contructor.
	 */
	constructor(private restClient: RestClient) {
		this.i18n = GLOBALS.i18n;

		// salutations
		this.salutations = [
			{ label: this.i18n.v('salutation.MRS'), value: "MRS" },
			{ label: this.i18n.v('salutation.MR'), value: "MR" },
			{ label: this.i18n.v('salutation.FAMILY'), value: "FAMILY" },
			{ label: this.i18n.v('salutation.COMPANY'), value: "COMPANY" },
		];

		// genders
		this.genders = [
			{ label: this.i18n.v('gender.MAN'), value: "MAN" },
			{ label: this.i18n.v('gender.WOMAN'), value: "WOMAN" },
			{ label: this.i18n.v('gender.UNKNOWN'), value: "UNKNOWN" }
		];

		// empty noSelection
		this.noSelectionOption = { "value": null, "label": this.i18n.v('pleaseSelect') };
	}

}
